import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SeekBackward30Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SeekBackward30",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m23.19 4-.6-.32c-5-2.67-11.11-2.06-15.47 1.56L4.48 3.83c-.18-.1-.4-.08-.55.05-.16.12-.24.33-.19.53l1.68 6.29c.03.13.12.24.24.31s.27.08.41.04l6.17-2.09c.19-.06.33-.24.34-.44.02-.2-.08-.4-.26-.5L9.64 6.59l.55-.34c3.41-2.07 7.66-2.18 11.17-.28l.19.1c4.68 2.64 6.88 8.19 5.29 13.32-.14.43-.3.86-.49 1.28a11.18 11.18 0 0 1-6.71 6.05c-5.92 2.02-12.36-1.15-14.38-7.07-.34-.99-.54-2.02-.59-3.06a1.3 1.3 0 0 0-2.01-1.08c-.41.26-.65.71-.64 1.2.39 7.71 6.96 13.65 14.67 13.26 1.3-.07 2.58-.31 3.8-.73 3.7-1.22 6.71-3.94 8.29-7.5.15-.29.25-.61.36-.9 2.33-6.31-.17-13.39-5.95-16.83Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.18 18.75c-.21.12-.43.19-.68.19-.23 0-.43-.05-.62-.12-.19-.08-.38-.21-.57-.38-.18-.17-.36-.39-.54-.67l-1.11.7c.37.63.77 1.08 1.21 1.33.43.26.95.4 1.54.4.53 0 1.01-.12 1.45-.36q.645-.36 1.02-.96c.375-.6.38-.87.38-1.39a2.4 2.4 0 0 0-.72-1.75c-.22-.23-.48-.41-.78-.53-.26-.11-.55-.17-.84-.18l2.16-2.35-.27-.55h-4.66v1.3l2.71.02-1.97 2.17.37.96c.18-.07.34-.12.5-.18.15-.05.29-.09.43-.11s.26-.04.39-.04c.27 0 .5.06.7.15.19.1.34.26.44.44.09.19.15.42.15.69s-.07.51-.19.73c-.12.21-.29.38-.5.49M17.6 19.7c.46.33 1.01.49 1.65.49s1.19-.16 1.66-.49c.46-.33.81-.8 1.06-1.41s.37-1.34.37-2.18-.12-1.57-.37-2.18-.6-1.08-1.06-1.41-1.01-.49-1.66-.49-1.19.16-1.65.49q-.69.495-1.05 1.41c-.36.915-.37 1.34-.37 2.18s.12 1.57.37 2.18q.375.915 1.05 1.41m.42-5.67c.29-.49.7-.74 1.23-.74s.94.25 1.23.74.44 1.18.44 2.08-.15 1.57-.44 2.06-.7.73-1.23.73-.94-.24-1.23-.73-.44-1.17-.44-2.06.15-1.58.44-2.08"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.43 11.29c-.29 0-.58-.11-.81-.33L9.05 6.39a1.14 1.14 0 0 1 0-1.62L13.62.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-3.76 3.76 3.76 3.76a1.14 1.14 0 0 1-.81 1.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 31.86c-7.56 0-13.71-6.15-13.71-13.71 0-3.53 1.34-6.89 3.77-9.45a1.15 1.15 0 0 1 1.62-.04c.46.44.48 1.16.04 1.62a11.36 11.36 0 0 0-3.14 7.87c0 6.3 5.13 11.43 11.43 11.43s11.43-5.13 11.43-11.43S21.88 6.72 15.58 6.72H9.87a1.14 1.14 0 1 1 0-2.28h5.71c7.56 0 13.71 6.15 13.71 13.71s-6.15 13.71-13.71 13.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 22.64v-2.37h.04c.78.56 1.56.84 2.38.84.89 0 1.4-.5 1.4-1.13 0-.57-.49-1.09-1.54-1.09h-1.1v-.09l1.42-2.61H8.8v-2.12h5.8v.13l-1.77 3.35c1.23.35 1.98 1.4 1.98 2.64 0 1.84-1.42 3.07-3.62 3.07-.97 0-1.86-.25-2.47-.62ZM15.84 18.6c0-2.76 1.53-4.66 3.74-4.66s3.83 1.9 3.83 4.66-1.57 4.66-3.83 4.66-3.74-1.9-3.74-4.66m5.2 0c0-1.75-.53-2.73-1.46-2.73-.88 0-1.37.98-1.37 2.73s.49 2.64 1.37 2.64c.93 0 1.46-.95 1.46-2.64"
      })]
    })
  }));
};
SeekBackward30Icon.displayName = 'SeekBackward30Icon';